import _ from "lodash";
import { WebViewJs } from './WebViewJs';
import { bindAndFreezeMethods } from "@fanfanlo";
import {IProjectData} from "@droid/project-interface"
import { IRhinoRunnerConf } from "@app/static"
export interface ICallScriptRunnerResult{
    runnerBridgeId:string
    runnerResult:string
    webViewJsUlid:string
}

export class AutoWebViewJs extends WebViewJs{
    static instance:AutoWebViewJs;
    constructor() {
        super();
        AutoWebViewJs.instance = this;
        autoWebViewJs = this;
        bindAndFreezeMethods(this);
    }
    static confToScript(conf:any){
        let c = _.merge({}, conf);
        let list = c.injects || [];
        let injects:any[] = [];
        for(let i = 0; i < list.length; i++){
            let item = list[i];
            let arr;
            if(_.isArray(item)){
                arr = item;
            }else if(_.isString(item)){
                arr = [item]
            }else if(_.isObject(item)){
                let i = item as any
                arr = [i.name, i.alias]
            }
            injects.push(arr);
        }
        c.injects = injects;
        var s = JSON.stringify(c);
        return s;
    }
    confToScript(conf:any){
        return AutoWebViewJs.confToScript(conf);
    }
    onCallNowPackageNodesJsonInfo<T>(){
        return this.callInterface<T>("onCallNowPackageNodesJsonInfo");
    }
    onCallGetA11yServiceLiveInfo<T>(){
        return this.callInterface<T>("onCallGetA11yServiceLiveInfo");
    }
    onCallOpenA11yPermission<T>(){
        return this.callInterface<T>("onCallOpenA11yPermission");
    }
    onCallGetA11yPermission<T>(){
        return this.callInterface<T>("onCallGetA11yPermission");
    }
    callScript<T>(script:string){
        return this.callInterface<T>("callScript", script);
    }
    callScriptRunner(script:string){
        return this.callInterface<ICallScriptRunnerResult>("callScriptRunner", script);
    }
    
    /**
     * 运行 Project
     * @param conf - RhinoRunner 配置对象,包含脚本、权限等信息
     * @param userId - 用户账户ID
     * @param projectName - 项目名称
     * @param projectId - 项目ID
     * @returns Promise<任意类型的返回结果>
     */
    runProject(conf: IRhinoRunnerConf, userId: string, projectName: string, projectId: string) {
        console.log('[AutoWebViewJs.runProject] 开始运行Project, scriptId:', conf.scriptId);
        console.log('[AutoWebViewJs.runProject] foregroundText:', conf.foregroundText);
        console.log('[AutoWebViewJs.runProject] permissions数量:', conf.permissions?.length ?? 0);
        console.log('[AutoWebViewJs.runProject] userId:', userId);
        console.log('[AutoWebViewJs.runProject] projectName:', projectName);
        console.log('[AutoWebViewJs.runProject] projectId:', projectId);

        const confJson = AutoWebViewJs.confToScript(conf);
        console.log('[AutoWebViewJs.runProject] 配置JSON长度:', confJson.length);

        const result = this.callInterface("runProject", confJson, userId, projectName, projectId);
        console.log('[AutoWebViewJs.runProject] callInterface完成');

        return result;
    }
    callScriptByConf(conf:any){
        let s = AutoWebViewJs.confToScript(conf);
        return this.callScriptRunner(s)
    }
    permissionHasFloat<T>(){
        let script = `var bl = com.fanfanlo.lib.permissions.FloatPermission.hasPermission();\n bl;`
        let res = this.callScript(script);
        if(res.javaResultData){
            let print = this.log.sub(false, "permissionHasFloat-try").print;
            try{ res.javaResultData = JSON.parse(res.javaResultData as string) as T }
            catch (e){ 
                print("permissionHasFloat-try error", e) 
                return {error:e}
            }
        }
        return res;
    }
    clipboardSetText(text:string){
        // return this.callScript(`com.fanfanlo.lib.utils.ClipboardUtils.Companion.setText("${text}")`);
        // return this.callScript(`com.fanfanlo.lib.utils.ClipboardUtils.Companion.setText(\`${text}\`)`);
        const s = text.replace(/\"/g, '\\"')
        return this.callScript(`com.fanfanlo.lib.utils.ClipboardUtils.Companion.setText("${s}")`);
    }
}
export function getAutoWebViewJs(){
    return AutoWebViewJs.instance
}
export var autoWebViewJs:AutoWebViewJs;